import createLucideIcon from '../createLucideIcon';

const ArrowBigDown = createLucideIcon('ArrowBigDown', [
  ['path', { d: 'M15 6v6h4l-7 7-7-7h4V6h6z', key: '1thax2' }],
]);

export default ArrowBigDown;
